import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import API from 'shared/constants/api';
import Loader from 'shared/components/Loader/Loader';
import NewsList from 'desktop/routes/journal/components/NewsList/NewsList';
import s from './TestDrives.css';
import { withFetch } from '../../../../../shared/hocs/withFetch';

class TestDrives extends React.Component {
  static propTypes = {
    make: PropTypes.number,
    model: PropTypes.number,
    year: PropTypes.number,
    generation: PropTypes.number,
    //
    fetch: PropTypes.func.isRequired,
  };
  static defaultProps = {
    make: undefined,
    model: undefined,
    year: undefined,
    generation: undefined,
  };

  state = {
    isFetching: true,
    items: null,
  };

  componentDidMount() {
    const { make, model, year, generation } = this.props;

    this.props
      .fetch(
        API.JOURNAL.TEST_DRIVES({
          make,
          model,
          year,
          generation,
        }),
      )
      .then(r => r.json())
      .then(response => {
        this.setState({ isFetching: false, items: response.results });
      });
  }

  render() {
    const { items, isFetching } = this.state;

    return (
      <div className={s.root}>
        <Loader isLoading={isFetching}>
          {items && <NewsList news={items} shortView />}
          {items &&
            items.length === 0 &&
            <div className={s.emptyMessage}>
              <FormattedMessage id="Тест-драйвы для данной модели ещё не опубликованы" />
            </div>}
        </Loader>
      </div>
    );
  }
}

export default withStyles(s)(withFetch(TestDrives));



// WEBPACK FOOTER //
// ./src/desktop/routes/advert/components/TestDrives/TestDrives.js